import { render, staticRenderFns } from "./AddProductsToPortfolioModalContent.vue?vue&type=template&id=c85ccbf2&scoped=true&"
import script from "./AddProductsToPortfolioModalContent.vue?vue&type=script&lang=js&"
export * from "./AddProductsToPortfolioModalContent.vue?vue&type=script&lang=js&"
import style0 from "./AddProductsToPortfolioModalContent.vue?vue&type=style&index=0&id=c85ccbf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85ccbf2",
  null
  
)

export default component.exports